/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketGoogleStoreProductListRequest model module.
 * @module model/MarketGoogleStoreProductListRequest
 * @version 1.0
 */
class MarketGoogleStoreProductListRequest {
    /**
     * Constructs a new <code>MarketGoogleStoreProductListRequest</code>.
     * @alias module:model/MarketGoogleStoreProductListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MarketGoogleStoreProductListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MarketGoogleStoreProductListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketGoogleStoreProductListRequest} obj Optional instance to populate.
     * @return {module:model/MarketGoogleStoreProductListRequest} The populated <code>MarketGoogleStoreProductListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketGoogleStoreProductListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('listType')) {
                obj['listType'] = ApiClient.convertToType(data['listType'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketGoogleStoreProductListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketGoogleStoreProductListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MarketGoogleStoreProductListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

MarketGoogleStoreProductListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MarketGoogleStoreProductListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MarketGoogleStoreProductListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MarketGoogleStoreProductListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} listType
 */
MarketGoogleStoreProductListRequest.prototype['listType'] = undefined;






export default MarketGoogleStoreProductListRequest;

